import styled from "styled-components";

export const ExerciseStateBox = styled.div`
  gap: 12px;
  width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;
`;

export const ExerciseStateTit = styled.div`
  gap: 6px;
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  align-items: center;
`;

export const ExerciseStateContent = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
`;

export const DdayBox = styled.div`
  color: ${(props) => props.theme.colors.white100};
  display: flex;
  padding: 5px 7px;
  font-size: 1rem;
  background: ${(props) => props.theme.colors.black80};
  font-weight: 600;
  border-radius: 4px;
  letter-spacing: initial;
`;

export const ParticipationCount = styled.div`
  width: 10vw;
  color: ${(props) => props.theme.colors.white100};
  height: 5.5vw;
  display: flex;
  font-size: 1rem;
  background: ${(props) => props.theme.colors.black80};
  align-items: center;
  border-radius: 4px;
  justify-content: center;
`;
